/**
 * Çalışan istemcinin sürümü.
 *
 * Hesap ekranında "hangi sürüm yüklü?" sorusuna cevap verir: Android
 * paketinde `App.getInfo()` (versionName + versionCode), web'de tarayıcı
 * istemcisi. Sunucu sürümü ayrıca yeteneklerden gelir.
 */
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useEffect, useState } from 'react';

export interface ClientVersion {
  native: boolean;
  version: string;
  build: string | null;
}

/** Ekranda gösterilecek kısa etiket. */
export function clientVersionLabel(value: ClientVersion): string {
  if (!value.native) return 'Web (tarayıcı)';
  return value.build === null ? `v${value.version}` : `v${value.version} (${value.build})`;
}

/** Aktif istemci türü. */
export function clientKindLabel(value: ClientVersion): string {
  return value.native ? 'Android Uygulaması' : 'Web Arayüzü (Bu Tarayıcı)';
}

export function useClientVersion(): ClientVersion {
  const [value, setValue] = useState<ClientVersion>(() =>
    Capacitor.isNativePlatform()
      ? { native: true, version: '…', build: null }
      : { native: false, version: 'web', build: null },
  );

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;
    let cancelled = false;
    void App.getInfo()
      .then((info) => {
        if (cancelled) return;
        setValue({
          native: true,
          version: info.version,
          build: info.build === '' ? null : info.build,
        });
      })
      .catch(() => {
        if (!cancelled) setValue({ native: true, version: 'bilinmiyor', build: null });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return value;
}
